import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface IFRSListItemDTO {
  id: string;
  title: string;
  duration: number;
  createdAt: string;
}

export interface IFRSMetaDTO {
  total: number;
  page: number;
  lastPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetAllIFRSResponse {
  data: IFRSListItemDTO[];
  meta: IFRSMetaDTO;
}

interface GetAllIFRSParams {
  page?: number;
  limit?: number;
  sort?: "asc" | "desc";
  courseId?: string;
  search?: string;
}

type GetAllIFRSAPIResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: GetAllIFRSResponse;
};

export const GetAllIFRS = async ({
  page = 1,
  limit = 10,
  sort = "asc",
  search,
}: // courseId,
GetAllIFRSParams = {}): Promise<GetAllIFRSAPIResponse> => {
  try {
    const response = await axios.get(`/ifrs`, {
      params: { page, limit, sort, ...(search ? { search } : {}) },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
